export enum AssistantActionsEnum {
  waiting = 'waiting',
  listening = 'listening',
  thinking = 'thinking',
  writing = 'writing',
}
